import { TableCell } from "@mui/material";
import {
  IFreezeCalculationsTableReport,
  IFreezeRequestsTableReport,
} from "../../../Interfaces/freeze";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import Button from "../../../Components/Button";
import { SendOutlined } from "@ant-design/icons";
import { useState } from "react";
import {
  addBulkFreezeRequest,
  addBulkReleaseRequest,
  addFreezeRequest,
  editFreezeCalc,
} from "../../../Requests/freeze";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import SimpleTextInput from "../../../Components/SimpleTextInput";
import EditIcon from "@mui/icons-material/Edit";

const AdditionalHeader = ({
  onAction,
  selectedRowsIds,
  setSelectedRowsIds,
}: IAdditionalHeaderProps) => {
  const [bulkReleaseLoading, setBulkReleaseLoading] = useState(false);

  const bulkAddReleaseHandler = () => {
    if (!selectedRowsIds.length) return;
    setBulkReleaseLoading(true);
    addBulkFreezeRequest(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setSelectedRowsIds([]);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setBulkReleaseLoading(false));
  };

  return (
    <>
      <TableCell>
        <Button
          text={<SendOutlined className="!text-sm" />}
          variant="outlined"
          className="table-btn"
          onClick={bulkAddReleaseHandler}
          loading={bulkReleaseLoading}
          disabled={bulkReleaseLoading || !selectedRowsIds.length}
        />
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IFreezeCalculationsTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [addFreezeLoading, setAddFreezeLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [amount, setAmount] = useState(row.amount);

  const addFreezeHandler = () => {
    setAddFreezeLoading(true);
    addFreezeRequest(row.id)
      .then((resp) => {
        toast.success(resp.msg);
        onAction();
      })
      .catch(packetErrorHandler)
      .finally(() => setAddFreezeLoading(false));
  };

  const editHandler = () => {
    setEditLoading(true);
    editFreezeCalc({ amount, requestId: row.id })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setEditLoading(false));
  };

  return (
    <>
      <TableCell>
        <Button
          text={<SendOutlined className="!text-sm" />}
          variant="contained"
          className="table-btn"
          onClick={addFreezeHandler}
          loading={addFreezeLoading}
        />
      </TableCell>
      <TableCell>
        <div className="flex flex-row justify-start items-center gap-3">
          <div className="w-32">
            <SimpleTextInput
              name=""
              onChange={(_, value) => setAmount(value)}
              placeholder="مقدار"
              kind="number"
              value={amount?.toString()}
            />
          </div>
          <div className="w-32">
            <Button
              text={<EditIcon className="!text-sm" />}
              variant="contained"
              className="table-btn"
              onClick={editHandler}
              loading={editLoading}
            />
          </div>
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IFreezeCalculationsTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
